module.exports = __webpack_public_path__ + "static/img/Busqueda.a42218a8.png";